"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.freeze");

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _styles = require("@material-ui/core/styles");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n\n  a, a:hover, a:active {\n    text-decoration: none;\n    color: ", ";\n  }\n\n  a:hover {\n    color: ", ";\n  }\n\n  .section--latest-post {\n    p:last-of-type {\n      margin: 0;\n    }\n  }\n\n  .has-scrolled {\n    .section--footnotes {\n      position: static !important;\n      transition-property: background-color;\n      transition-duration: 600ms;\n      transition-timing-function: ease;\n      .footnote__title {\n        color: #fff;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.typography.color.main;
}, function (props) {
  return props.theme.palette.primary.dark;
}, function (props) {
  return props.theme.palette.primary.main;
});

function withTheme(Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$pageWidth = _ref.pageWidth,
      pageWidth = _ref$pageWidth === void 0 ? 'md' : _ref$pageWidth,
      palette = _ref.palette,
      typography = _ref.typography;

  var WithTheme = /*#__PURE__*/function (_react$default$Compon) {
    _inheritsLoose(WithTheme, _react$default$Compon);

    var _super = _createSuper(WithTheme);

    function WithTheme(props) {
      var _this;

      _this = _react$default$Compon.call(this, props) || this;
      _this.theme = (0, _Theme.create)({
        mode: mode,
        pageWidth: pageWidth,
        palette: palette,
        typography: typography
      });
      return _this;
    }

    var _proto = WithTheme.prototype;

    _proto.componentDidMount = function componentDidMount() {
      // Remove the server-side injected CSS.
      var jssStyles = document.querySelector('#jss-server-side');

      if (jssStyles && jssStyles.parentNode) {
        jssStyles.parentNode.removeChild(jssStyles);
      }
    };

    _proto.render = function render() {
      return _react["default"].createElement(_styles.MuiThemeProvider, {
        theme: this.theme
      }, _react["default"].createElement(_CssBaseline["default"], null), _react["default"].createElement(GlobalStyle, {
        theme: this.theme
      }), _react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: this.theme
      }, _react["default"].createElement(Component, this.props)));
    };

    return WithTheme;
  }(_react["default"].Component);

  return WithTheme;
}

var _default = withTheme;
exports["default"] = _default;